const UnitKerjaSearchCategories = [
  "pk",
  "kode_unit_kerja: ",
  "nama_unit_kerja",
  "nama_kepala",
  "nama_jabatan",
  "email_milis",
  "nama_unit_kerja_lokal",
  "email_pic",
  "show",
  "kode_baru",
];

export default UnitKerjaSearchCategories;
